import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Clarity from '@microsoft/clarity';

const CLARITY_PROJECT_ID = "snp2xab9ya";

export default function useClarity(userId) {
    const location = useLocation();

    // Initialize Clarity once
    useEffect(() => {
        if (import.meta.env.MODE === 'production' && Clarity && Clarity.init) {
            Clarity.init(CLARITY_PROJECT_ID);
        }
    }, []);

    // Identify user if available
    useEffect(() => {
        if (import.meta.env.MODE === 'production' && userId && Clarity?.identify) {
            Clarity.identify(userId);
        }
    }, [userId]);

    // Track SPA route changes without splitting sessions
    useEffect(() => {
        if (import.meta.env.MODE === 'production' && Clarity?.event) {
            Clarity.event("route_change", {
                page: location.pathname + location.search,
            });
        }
    }, [location]);
}
